import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useOAuth } from "common/hooks/useOAuth";
import { Constants } from "constants/Constants";

function Callback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Utiliser 'microsoft' par défaut, mais on pourrait le rendre configurable
  const oAuthProvider =
    (Constants.LOGIN_PROVIDER as "microsoft" | "google") || "microsoft";
  const { handleAuthCallback } = useOAuth(oAuthProvider);

  useEffect(() => {
    const processCallback = async () => {
      try {
        // Récupérer l'access_token depuis l'URL
        const accessToken = searchParams.get("access_token");

        if (!accessToken) {
          console.error("Access token non trouvé dans l'URL");
          setError("Access token non trouvé dans l'URL");
          setTimeout(() => {
            navigate("/login");
          }, 2000);
          return;
        }

        // Utiliser handleAuthCallback du hook
        await handleAuthCallback(accessToken);

        // Rediriger vers la page d'accueil après succès
        navigate("/");
      } catch (error) {
        console.error("Erreur callback:", error);
        setError("Erreur lors de la connexion. Redirection...");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    };

    if (!done) {
      setDone(true);
      processCallback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, navigate, done]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        gap: "1rem",
      }}
    >
      {error ? (
        <>
          <p style={{ color: "red" }}>{error}</p>
          <p>Redirection en cours...</p>
        </>
      ) : (
        <p>Connexion en cours...</p>
      )}
    </div>
  );
}

export default Callback;
